export const backendURL =
  process.env.NODE_ENV === 'production' ? 'https://thehub.cpandr.co.uk' : 'http://localhost:5001';
